import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "px-2 py-2 text-xs text-clay-800"
}
const _hoisted_3 = {
  key: 1,
  class: "px-2 py-2 text-xs text-red-500"
}
const _hoisted_4 = { class: "relative w-full max-w-full text-left" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = {
  key: 0,
  "aria-labelledby": "menu-button",
  "aria-orientation": "vertical",
  class: "px-6 pb-6 rounded-lg bg-zinc-50",
  role: "menu",
  tabindex: "-1",
  "x-transition:enter": "transition ease-out duration-200",
  "x-transition:enter-end": "transform opacity-100 scale-100",
  "x-transition:enter-start": "transform opacity-0 scale-95",
  "x-transition:leave": "transition ease-in duration-75",
  "x-transition:leave-end": "transform opacity-0 scale-95",
  "x-transition:leave-start": "transform opacity-100 scale-100"
}
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "sm:hidden" }
const _hoisted_9 = ["value", "selected"]
const _hoisted_10 = { class: "hidden sm:block" }
const _hoisted_11 = { class: "border-b border-gray-200" }
const _hoisted_12 = {
  class: "flex -mb-px",
  "aria-label": "Tabs"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "px-2 mt-4 space-y-1",
  style: {"max-height":"400px","overflow-y":"scroll"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "text-sm font-medium text-gray-700 underline" }
const _hoisted_18 = {
  class: "w-full py-1 md:grid md:grid-cols-3",
  role: "none"
}
const _hoisted_19 = ["alt", "title", "onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  class: "w-full py-1 md:grid md:grid-cols-2",
  role: "none"
}
const _hoisted_22 = ["alt", "onClick"]

import {computed, Ref, ref} from "vue";
import {
    Region,
} from "@/dtos";

import {Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions} from '@headlessui/vue';
import {CheckIcon, ChevronDownIcon,ChevronUpIcon} from '@heroicons/vue/20/solid';

import _ from "lodash";


export default /*@__PURE__*/_defineComponent({
  __name: 'TerritoriesTab',
  props: {
    territories: {
        type: Array,
        default: []
    },
    allowMultiple:{
        type: Boolean,
        default: false
    },
    modelValue: {
        type: Object,
        default: {}
    }
},
  emits: ['update:modelValue', 'onRegionSelected'],
  setup(__props, { emit: __emit }) {

// @ts-ignore
const props = __props

const openBrowseMore = ref(false);

const emit = __emit

const territoryQuery = ref('');

const filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? props.territories
        : props.territories.filter((territory: Region) => {
                return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)

const usTerritoriesGroupedByState = computed(() => {
    let groupedByStateMap = new Map(Object.entries(_.groupBy(getTerritories("United States"), x=>x.states.join(", "))));
    let groupedByStateSorted = new Map([...groupedByStateMap.entries()].sort());
    //console.log(groupedByStateSorted);
    return groupedByStateSorted
});

const getTerritories = (name: string) => {
    switch (name) {
        case "UK":
            return props.territories.filter((t: Region) => t.country === "United Kingdom");

        case "More":
            return props.territories.filter((t: Region) => t.country 
                !== "United States"
                && t.country !== "Canada"
                && t.country !== "Australia"
                && t.country !== "United Kingdom");
            
        default:
            return props.territories.filter((t: Region) => t.country === name)
    }
}

const tabs = ref([
    {
        name: "United States"
    },
    {
        name: "Canada",
    },
    {
        name: "UK",
    },
    {
        name: "Australia",
    },
    {
        name: "More"
    }
]);

let currentTab = ref(tabs.value[0]);

const onTabChanged = (tab: any) => {
    currentTab.value = tab;
};

const onRegionSelected = (territory: Region) =>{
    emit('onRegionSelected', territory);
    openBrowseMore.value = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Combobox), {
      modelValue: __props.modelValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = value => emit('onRegionSelected', value)),
      multiple: __props.allowMultiple,
      as: "div",
      class: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ComboboxInput), {
            class: "w-full py-2 pl-3 pr-10 bg-white border border-clay-500 rounded-md shadow-sm focus:border-clay-500 focus:outline-hidden focus:ring-1 focus:ring-clay-500 sm:text-sm",
            placeholder: "Start typing a region..",
            displayValue: __props.allowMultiple ? '' : (t) => t.name,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (territoryQuery.value = $event.target.value))
          }, null, 8, ["displayValue"]),
          _createVNode(_unref(ComboboxButton), {
            "aria-label": "Expand Regions Button",
            class: "absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden"
          }),
          _createVNode(_unref(ComboboxOptions), { class: "absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTerritories.value, (territory) => {
                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                  key: territory.id,
                  value: territory,
                  as: "template"
                }, {
                  default: _withCtx(({ active, selected }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass(['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900'])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                      }, _toDisplayString(territory.name), 3),
                      selected
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600'])
                          }, [
                            _createVNode(_unref(CheckIcon), {
                              "aria-hidden": "true",
                              class: "w-5 h-5"
                            })
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        (filteredTerritories.value.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Type in a city or region name and select from the dropdown list."))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, "The city you entered is not in our database. Please input a larger nearby city, or select a city from the list below. "))
      ]),
      _: 1
    }, 8, ["modelValue", "multiple"]),
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"relative mt-4\"><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\"><div class=\"w-full border-t border-clay-500\"></div></div><div class=\"relative flex justify-center text-sm\"><span class=\"px-2 text-clay-800 bg-white\"> OR </span></div></div>", 1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          id: "menu-button",
          class: "inline-flex items-center min-w-full px-3 py-2 mx-auto text-sm font-medium border border-clay-500 rounded-md shadow-sm text-clay-950 hover:bg-clay-50 bg-clay-100",
          type: "button",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (openBrowseMore.value =! openBrowseMore.value), ["prevent"]))
        }, [
          _cache[4] || (_cache[4] = _createTextVNode(" Browse By Region ")),
          (openBrowseMore.value)
            ? (_openBlock(), _createBlock(_unref(ChevronUpIcon), {
                key: 0,
                class: "w-5 h-5 ml-2 -mr-1"
              }))
            : (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                key: 1,
                class: "w-5 h-5 ml-2 -mr-1"
              }))
        ])
      ]),
      (openBrowseMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                  for: "tabs",
                  class: "sr-only"
                }, "Select a region", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "tabs",
                  name: "tabs",
                  class: "block w-full px-3 py-2 border rounded-md border-clay-300 focus:border-clay-500 focus:ring-clay-500 dark:text-white",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(currentTab) ? (currentTab).value = $event : currentTab = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: tab.name,
                      value: tab,
                      selected: tab.name === _unref(currentTab).name
                    }, _toDisplayString(tab.name), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(currentTab)]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("nav", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: tab.name,
                        onClick: _withModifiers(($event: any) => (onTabChanged(tab)), ["prevent"]),
                        class: _normalizeClass([tab.name === _unref(currentTab).name ? 'border-clay-500 text-clay-600' : 'border-transparent text-clay-800 hover:border-clay-500 hover:text-gray-700', 'w-1/4 border-b-2 py-4 px-1 text-center text-sm font-medium'])
                      }, _toDisplayString(tab.name) + " (" + _toDisplayString(getTerritories(tab.name).length) + ")", 11, _hoisted_13))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_unref(currentTab).name ==='United States')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usTerritoriesGroupedByState.value, ([states, territories]) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("h4", _hoisted_17, _toDisplayString(states), 1),
                        _createElementVNode("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(territories, (territory) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: territory.id,
                              alt: territory.name,
                              title: territory.name,
                              onClick: _withModifiers(($event: any) => (onRegionSelected(territory)), ["prevent"]),
                              class: "block px-2 py-2 text-sm text-gray-700 hover:bg-zinc-100 hover:font-bold hover:text-clay-950"
                            }, _toDisplayString(territory.name), 9, _hoisted_19))
                          }), 128))
                        ])
                      ]))
                    }), 256))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTerritories(_unref(currentTab).name), (territory) => {
                        return (_openBlock(), _createElementBlock("a", {
                          alt: territory.name,
                          onClick: _withModifiers(($event: any) => (onRegionSelected(territory)), ["prevent"]),
                          class: "block px-2 py-2 text-sm text-gray-700 hover:bg-zinc-100 hover:font-bold hover:text-clay-950",
                          title: ""
                        }, _toDisplayString(territory.name), 9, _hoisted_22))
                      }), 256))
                    ])
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})